import { useEffect } from "react";

/**
 * 로그인/회원가입 화면 동안 <html> 에 `auth-screen` 클래스를 부여한다.
 * - global.css 가 이 클래스를 보고 html/body 배경을 파란색으로 칠해
 *   iOS Safari 오버스크롤(고무줄)·노치·홈인디케이터 안전영역까지 빈틈 없이 채운다.
 * - 화면을 떠나면 클래스를 제거해 앱 화면(회색 배경)은 영향받지 않는다.
 */
export function useAuthScreenChrome() {
  useEffect(() => {
    const html = document.documentElement;
    html.classList.add("auth-screen");
    return () => html.classList.remove("auth-screen");
  }, []);
}
